export interface RecipeCustomerDiary {
  RecipeCustomerDiaryId: string;
  CustomerId: string;
  RecipeCustomerHeaderId: string;
  ActionType: number;
  ActionSummary: string;
  AdditionalData: string;
  ChangeByUser: string;
  CreateDate: Date | string;
  ChangeDate: Date | string;
  DeleteDate?: Date | string;
  CanRevert: boolean;
}

export type RevertRecipeCustomerDiaryActionRequest = {
  RecipeCustomerDiaryId: string;
};

export enum RecipeCustomerDiaryActionType {
  RecipeCategory_Add = 0,
  RecipeCategory_Update = 1,
  RecipeCategory_Remove = 2,

  RecipeCustomerUserManage_Add = 3,
  RecipeCustomerUserManage_Remove = 4,

  RecipeCustomerShare_Add = 5,
  RecipeCustomerShare_Remove = 6,

  RecipeHeader_Remove = 7,
  RecipeCategory_Recover = 8,
}
